<template>
    <div class="checkout" v-if="currentPayment.payment_ref != ''">                
        <template v-if="$store.state.payments.errorKey == null">
            <div class="checkout__title">
                Introduceti datele cardului
            </div>
            <!-- <card class="checkout__input"
                ref='card'
                :class='{ complete }'
                :stripe='getStripeKey()'
                :options='stripeOptions'
                @change='complete = $event.complete, $emit("complete", $event.complete)'
                @escape='escapePayment'
            /> -->

            <StripeElements
            :stripe-key="getStripeKey()"
            :instance-options="instanceOptions"
            :elements-options="elementsOptions"
            #default="{ elements }"
            ref="elms"
            >
                <StripeElement
                    type="card"
                    :elements="elements"
                    :options="cardOptions"
                    :class='{ complete }'
                    @change='complete = $event.complete, $emit("complete", $event.complete)'
                    @escape='escapePayment'
                    ref="card"
            />
            </StripeElements>
            <small class="checkout__info">
                *Factura se va emite in baza detaliilor din setarile contului dvs.
            </small>

            <div class="checkout__divider"></div>

            <div class="checkout__title">
                Detalii plata
            </div>

            <div class="checkout__list">
                <div class="checkout__list--title">
                    Descriere:
                </div>
                <div class="checkout__list--value">
                    {{ this.paymentType || 'Alimentare cont' }}
                </div>
            </div>
            <div class="checkout__list">
                <div class="checkout__list--title">
                    Subtotal:
                </div>
                <div class="checkout__list--value">
                    {{ getDecimals(currentPayment.subtotal) }} {{currentPayment.currency}}
                </div>
            </div>

            <div class="checkout__list">
                <div class="checkout__list--title">
                    Taxe (TVA):
                </div>
                <div class="checkout__list--value">
                    {{ getDecimals(currentPayment.vat) }} {{currentPayment.currency}}
                </div>
            </div>

            <div class="checkout__divider"></div>

            <div class="checkout__total">
                <div class="checkout__total--title">
                    Total:
                </div>
                <div class="checkout__total--value">
                    {{ getDecimals(currentPayment.total) }} {{currentPayment.currency}}
                </div>
            </div>
        </template>
        <template v-else>
            <div class="checkout__errors">
                {{ errorMessages[$store.state.payments.errorKey] }}
            </div>
            <div class="checkout__errors">                
                <div class="checkout__error" v-if="errorCode.length">
                    Cod de eroare:
                    <span class="checkout__error--code">
                        {{ errorCode }}
                    </span>
                    | {{ errorMessages[errorCode] }}
                </div>
                <div class="checkout__error" v-if="errorSubcode.length">
                    Subcod de eroare:
                    <span class="checkout__error--code">
                        {{ errorSubcode }}
                    </span>
                    | {{ errorMessages[errorSubcode] }}
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { StripeElements, StripeElement, confirmCardPayment } from 'vue-stripe-elements-plus'
import UiButton from '@/components/ui/Button'
import config from '@/config.js'
import { mapActions, mapGetters } from 'vuex'

export default {
    props: {
        submitPayment: {
            type: Boolean,
            default: false
        },
        retry:  {
            type: Boolean,
            default: false
        }
    },
    watch: {
        submitPayment: {
            handler(value, oldValue) {
                if(value == true) {
                    this.$store.state.payments.isLoading = true;
                    console.log('clicked pay');
                    this.pay();
                }
            }
        }
    },
    data () {
        return {
            complete: false,
            instanceOptions: {},
            elementsOptions: {
                clientSecret: this.$store.state.payments.current.client_secret,
                locale: "ro",
            },
            cardOptions: {
                hidePostalCode: true,
            },
            errorMessages: {
                general: "A apărut o problemă la procesarea plății. Te rugăm să reîncerci sau contactează-ne.",
      
                card_declined: "Cardul a fost refuzat.",
                processing_error: "A apărut o eroare la procesarea cardului.",
                live_mode_test_card: "Cardul este dedicat testelor.",
                
                do_not_honor: "Cardul a fost refuzat. Contactați banca dvs. pentru mai multe detalii.",
                call_issuer: "Cardul a fost refuzat. Contactați banca dvs. pentru mai multe detalii.",
                do_not_try_again: "Cardul a fost refuzat. Contactați banca dvs. pentru mai multe detalii.",
                generic_decline: "Cardul a fost refuzat. Contactați banca dvs. pentru mai multe detalii.",
                currency_not_supported: "Cardul introdus nu suportă această valută.",
                duplicate_transaction: "Tranzacție dublată.",
                expired_card: "Cardul introdus este expirat.",
                fraudulent: "Cardul introdus a fost refuzat, deoarece prezintă un risc ridicat de fraudă.",
                incorrect_number: "Numarul cardului introdus este incorect.",
                incorrect_cvc: "Codul CVC/CVV introdus este incorect.",
                invalid_cvc: "Codul CVC/CVV introdus este incorect.",
                insufficient_funds: "Fonduri insuficiente.",
                invalid_account: "Cont bancar invalid.",
                invalid_amount: "Suma invalidă.",
                invalid_expiry_month: "Luna expirării este invalidă.",
                invalid_expiry_year: "Anul expirării este invalid.",
                invalid_number: "Numarul cardului introdus este invalid.",
                issuer_not_available: "Banca dvs. nu a putut fi contactată.",
                lost_card: "Plata nu a fost realizată, deoarece acest card apare ca fiind pierdut.",
                merchant_blacklist: "Cardul introdus se află pe Black List.",
                not_permitted: "Operațiunea nu este permisă."
            },
            errorCode: '',
            errorSubcode: '',
        }
    },
    components: {
        UiButton,
        StripeElements,
        StripeElement
    },
    computed: {
        ...mapGetters({
            currentPayment: 'payments/current',
            user:  'user/user'
        }),
        paymentType() {
            switch(this.currentPayment.payment_type){
                case 'TOPUP':
                    return 'Alimentare cont';
                case 'APPOINTMENT':
                    return 'Finalizare programare';
                case 'SERVICE':
                    return 'Achiziție ședință';
                case 'PACKAGE':
                    return 'Achiziție pachet';
                case 'TIPS':
                    return 'Tips';
            }

            return 'Alimentare cont';
        }
    },
    methods: {
        ...mapActions({
            checkPayment: 'payments/check',
        }),
        pay() {
            const groupComponent = this.$refs.elms;
            const cardComponent = this.$refs.card;
            console.log("next step: confirmCardPayment")
            groupComponent.instance.confirmCardPayment(this.elementsOptions.clientSecret, {
                payment_method: {
                    card: cardComponent.stripeElement,
                    billing_details: {
                        name: this.user.first_name + " " + this.user.last_name,
                    }
                }
            }).then((result) => {
                if (result.error) {
                    this.errorCode = result.error.code;
                    if(result.error.code == "card_declined") {
                        
                        if( this.errorMessages.hasOwnProperty(result.error.decline_code) ) {
                            this.errorSubcode = result.error.decline_code;
                            this.$store.state.payments.errorKey = result.error.decline_code;
                        } 
                        else
                            this.$store.state.payments.errorKey = 'general';
                            
                    } else if( this.errorMessages.hasOwnProperty(result.error.code) )
                        this.$store.state.payments.errorKey = result.error.code;
                    else
                        this.$store.state.payments.errorKey = 'general';
                    
                    this.$refs.card.stripeElement.clear();
                    this.$emit('paymentFailed');
                    return;
                } else {
                    this.$store.state.payments.isLoading = false;
                    const data = {
                        ref: this.currentPayment.payment_ref,
                        intent_id: result.paymentIntent.id,
                    };        

                    this.checkPayment(data);
                    this.$refs.card.stripeElement.clear();
                }   
            });
            // createSource().then(response => {
            //     console.log(response);
            //     this.$store.state.payments.isLoading = false;
                
            //     if(response.hasOwnProperty('error')) {
            //         this.errorCode = response.error.code;
                    
            //         if(response.error.code == "card_declined") {
                        
            //             if( this.errorMessages.hasOwnProperty(response.error.decline_code) ) {
            //                 this.errorSubcode = response.error.decline_code;
            //                 this.$store.state.payments.errorKey = response.error.decline_code;
            //             } 
            //             else
            //                 this.$store.state.payments.errorKey = 'general';
                            
            //         } else if( this.errorMessages.hasOwnProperty(response.error.code) )
            //             this.$store.state.payments.errorKey = response.error.code;
            //         else
            //             this.$store.state.payments.errorKey = 'general';
                    
            //         this.$refs.card.clear();
            //         this.$emit('paymentFailed');
            //         return;
            //     }
                
            //     const data = {
            //         ref: this.currentPayment.payment_ref,
            //         client_secret: this.currentPayment.client_secret,
            //         stripeSource: response.source.id
            //     };

            //     console.log(data);
                                
            //     //this.finishPayment(data);
            //     this.$refs.card.clear();
            // }).catch((erorr) => {
            //     console.log(error);
            // });
        },
        getStripeKey() {
            return config.STRIPE_KEY;
        },
        getDecimals(number) {
            return (Math.round(number * 100) / 100).toFixed(2);
        },
        escapePayment() {
            console.log('escapePayment');
        }
    }
}
</script>

<style lang="scss" scoped>
    .checkout {
        margin: 30px 0px 50px 0px;

        &__title {
            font-family: 'DIN Pro', sans-serif;
            font-style: normal;
            font-weight: 500;
            font-size: 20px;
            line-height: 20px;
            color: $color-gray;
        }
        
        &__message {
            font-family: 'DIN Pro', sans-serif;
            font-style: normal;
            font-weight: 500;
            font-size: 19px;
            line-height: 20px;
            color: $color-gray;
            margin-top: 20px;
            margin-bottom: 20px;
        }
        
        &__errors {
            font-family: 'DIN Pro', sans-serif;
            font-style: normal;
            font-weight: 500;
            font-size: 19px;
            line-height: 20px;
            color: $color-gray;
            margin-top: 20px;
            margin-bottom: 20px;
            text-align: center;
        }
        
        &__error {
            font-family: 'DIN Pro', sans-serif;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 16px;
            color: $color-gray;
            text-align: center;
            margin-top: 10px;
            
            &--code {
                font-family: 'DIN Pro', sans-serif;
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
                line-height: 16px;
                color: $color-primary;
                text-align: center;
                margin-left: 5px;
            }
        }
        
        &__input {
            margin-top: 10px;
            box-sizing: content-box;
            margin-bottom: 20px;
        }
        &__divider {
            height: 1px;
            width: 100%;
            margin: 10px 0;
            background: rgba($color-gray, 0.25);
        }

        &__info {
            font-family: 'DIN Pro', sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 20px;
            color: rgba($color-gray, 0.7);
        }

        &__list {
            display: flex;
            justify-content: space-between;
            margin: 10px 0px;

            &--title {
                font-family: 'Roboto', sans-serif;;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 20px;
                color: rgba($color-gray, 0.7);
            }

            &--value {
                font-family: 'Roboto', sans-serif;;
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
                text-align: right;
                color: rgba($color-gray, 0.7);
            }
        }

        &__total {
            display: flex;
            justify-content: space-between;
            margin: 10px 0px;

            &--title {
                font-family: 'Roboto', sans-serif;
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
                line-height: 20px;
                color: $color-gray;
            }

            &--value {
                font-family: 'Roboto', sans-serif;
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
                line-height: 20px;
                text-align: right;
                color: rgba($color-gray, 0.7);
            }
        }
        &__cta {
            margin-top: 30px;
            display: flex;
        }
    }

</style>
<style lang="scss">
    .StripeElement {
        padding: 10px;
        margin: 15px 0px;
        border: 1px solid transparent;
        box-shadow: 0 1px 3px 0 #e6ebf1;
        -webkit-transition: box-shadow 150ms ease;
        transition: box-shadow 150ms ease;
    }
    .StripeElement--focus {
        box-shadow: 0 1px 3px 0 #cfd7df;
        border: 1px solid $color-secondary;
    }
    .StripeElement--invalid {
        border-color: $color-danger;
    }
    .StripeElement--webkit-autofill {
        background-color: $color-body !important;
    }
    .checkout__input {
        border: 1px solid $color-card-title;
    }
    .stripe-card.complete {
        border-color: $color-success;
    }
</style>
